import useLocalStorage from "@/hooks/use-local-storage";
import { useLaravelReactI18n } from "laravel-react-i18n";
import { PropsWithChildren, useEffect } from "react";

export default function BaseLayout({ children }: PropsWithChildren) {
    const { currentLocale, setLocale } = useLaravelReactI18n();
    const  [ preferredLanguage ] = useLocalStorage('preferredLanguage', currentLocale());

    useEffect(() => {
        if (preferredLanguage !== currentLocale()) {
            console.log('Set locale:', preferredLanguage);

            setLocale(preferredLanguage);
        }
    }, [preferredLanguage]);

    return (
        <>
            {children}
        </>
    );
}
